export default function formatToDecimal(number) {
    if (typeof number !== "number") {
      throw new Error("Input must be a number.");
    }
    if (number >= 1000) {
      return "$" + (Math.floor(number) + 0.0).toLocaleString("en-US");
    } else {
      return "$" + number.toLocaleString("en-US");
    }
  }
  